import { useAppCategories } from '@/entities/category'
import { ProductSearchForm, ProductSearchNavbar } from '@/entities/search-product'
import { useSearchCategoryFromRoute } from '@/features/search-in-category'
import { cn } from '@/shared/lib/cn'
import { NextImage } from '@/shared/lib/next'
import { useAppConfig } from '@/shared/ui/app-config-context'
import { HomeBlogPost } from '@/widgets/home-blog-post'

import { HomeScreenSlogan } from './slogan'
import { UpcomingEvChargingWidget } from './upcoming-ev-charging-widget'

export const HomeScreen: React.FC = () => {
  const { config_web: config } = useAppConfig()
  const categories = useAppCategories()
  const { categoryToShow } = useSearchCategoryFromRoute()
  const { homePage } = config.blog ?? {}

  const shouldShowBlog = homePage?.enabled && homePage.title

  return (
    <>
      <div
        className={cn(
          'relative z-0 grid grid-cols-1 content-start max-desktop:px-2 max-desktop:pb-24 desktop:px-4 desktop:pb-14',
          !shouldShowBlog && 'desktop:min-h-screen',
        )}
      >
        {!!config.images.home_hero && (
          <div className="absolute inset-0 z-[-1] overflow-hidden">
            <NextImage
              className="h-full w-full object-top"
              src={config.images.home_hero}
              alt={config.name}
              width={383}
              height={209}
              priority
            />
          </div>
        )}
        <HomeScreenSlogan slogan={config.slogan} className="mx-auto max-desktop:max-w-[var(--sn-body-min-width)]" />
        {categoryToShow && (
          <div className="mx-auto w-full gap-y-4 rounded-8 bg-white p-4 shadow-[0_2px_4px_0_rgba(5,29,46,0.2)] desktop:max-w-[892px]">
            {config.show_categories_menu && (
              <ProductSearchNavbar
                categories={categories}
                className="mb-4"
                controlDesktopLayout="vertical"
                activeCategory={categoryToShow}
                controlSemantics="anchor"
              />
            )}
            <ProductSearchForm categoryToShow={categoryToShow} />
          </div>
        )}

        {/* Upcoming EV Charging Events Widget */}
        <div className="max-desktop:hidden desktop:row-start-3">
          <UpcomingEvChargingWidget />
        </div>

        <div className="relative">
          <div className="desktop:hidden">
            <UpcomingEvChargingWidget />
          </div>
        </div>
      </div>
      {shouldShowBlog && <HomeBlogPost className="my-6 desktop:my-8" data={homePage} />}
    </>
  )
}
